import { useState } from "react";
import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import ProdWaterUsageTable from "./WaterUsage/Table";
import ProdMaterialUsedTable from "./Material/Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import manufacturingIcon from "../../../../../assets/new-product-detail-cats/sub-icons/prod-manufacturing-icon-white.svg";
import ProdSubBox from "../../components/SubcategoryBox";
import ProdEnergyComponents from "../../ProdEnergy";
import ProdSurplusResources from "../../ProdSurplusResource";
import "../index.css";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";

const ProdMaterialInputContents = ({ productId, systemBoundaryProps }) => {
  const { t } = useTranslation();

  const [showTable, setShowTable, isPDFMode, pdfInfo] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });

  const shouldShowTable = isPDFMode || showTable;
  const [showBox, setShowBox] = useState(false);

  return (
    <>
      {/* Add data attribute for PDF loading detection */}
      <div
        data-pdf-loading={isPDFMode && !pdfInfo.isPDFReady ? "true" : "false"}
      >
        <div
          className="cant-find-process-container"
          onClick={() => setShowBox(!showBox)}
        >
          <div className="cant-find-process">
            <div style={{ padding: "5px" }}>
              <h5>Can't find your process here?</h5>
            </div>
            <div className="cant-find-process-child">
              <h5>Create your own here</h5>
            </div>
          </div>
        </div>

        {(showBox || isPDFMode) && (
          <div className="process-custom-container">
            <div className="custom-manufacturing-process">
              <h5>Custom Manufacturing Process</h5>
              <p>
                In this section, you will be able to build your own custom
                processes that are specific to your manufacturing
              </p>
            </div>
            <div className="prod-manufacturing-contents">
              <SubHeaderBox
                subTitle={t("MANUFACTURING_INPUT")}
                subDescription={t("MANUFACTURING_INPUT_DESC")}
                isNormal={true}
                number={"12.2"}
                systemBoundaryProps={systemBoundaryProps}
                showSystemBoundary={true}
                icon={manufacturingIcon}
                customBGColor={"rgba(255,255,255,0.8"}
                customTextColor={"#00386D"}
              />

              <div>
                <ProdSubBox
                  title={t("MATERIAL_USAGE")}
                  desc={t("MATERIAL_USAGE_DESC")}
                />
                {shouldShowTable && pdfInfo.isPDFReady && (
                  <TableLoadingWrapper
                    tableId={`prod-materialinputmaterial-${productId}`}
                    minLoadTime={3000}
                    maxLoadTime={20000}
                  >
                    <ProdMaterialUsedTable productId={productId} />
                  </TableLoadingWrapper>
                )}
                {!isPDFMode && (
                  <ShowHideTable
                    showTable={showTable}
                    setShowTable={setShowTable}
                  />
                )}
              </div>

              <div>
                <ProdSubBox
                  title={t("WATER_USAGE")}
                  desc={t("WATER_USAGE_MANUFACTURING_DESC")}
                />
                {shouldShowTable && pdfInfo.isPDFReady && (
                  <TableLoadingWrapper
                    tableId={`prod-materialinputwater-${productId}`}
                    minLoadTime={3000}
                    maxLoadTime={20000}
                  >
                    <ProdWaterUsageTable productId={productId} />
                  </TableLoadingWrapper>
                )}
                {!isPDFMode && (
                  <ShowHideTable
                    showTable={showTable}
                    setShowTable={setShowTable}
                  />
                )}
              </div>
            </div>

            <ProdEnergyComponents productId={productId} />
            <ProdSurplusResources productId={productId} />
          </div>
        )}
      </div>
    </>
  );
};

export default ProdMaterialInputContents;
